export const DRAWER_TYPES = {
  CallList: 'CallList',
  ConvertSendoverToSendout: 'ConvertSendoverToSendout',
  CreateCall: 'CreateCall',
  CreateSendoutInterview: 'CreateSendoutInterview',
  CreateSendout: 'CreateSendout',
  CreateSendover: 'CreateSendover',
  Drafts: 'Drafts',
  Duplicates: 'Duplicates',
  SendoutDeclinationReasons: 'SendoutDeclinationReasons',
  SendoutDetails: 'SendoutDetails',
  SendoutDetailsEdit: 'SendoutDetailsEdit',
  SendoutInterviewDebriefDetails: 'SendoutInterviewDebriefDetails',
  SendoutInterviewDebriefEdit: 'SendoutInterviewDebriefEdit',
  SendoutInterviewDetails: 'SendoutInterviewDetails',
  SendoverDeclinationReasons: 'SendoverDeclinationReasons',
  SendoverDetails: 'SendoverDetails'
};
